// ======================================================================
// File: QuantityInput.jsx
// Module: PPE → Procurement → Purchase Request
//
// Purpose:
// - Controlled numeric quantity input
// - Prevents over-allocation
// ======================================================================

import React from "react";

export default function QuantityInput({
  value,
  max,
  onChange,
}) {

  const handleChange = (e) => {
    const inputValue = e.target.value;

    // Allow user to clear field while typing
    if (inputValue === "") {
      onChange("");
      return;
    }

    const val = parseFloat(inputValue);

    if (isNaN(val)) return;

    if (max !== undefined && val > max) return;

    onChange(val);
  };

  return (
    <input
      type="number"
      min="0"
      step="0.01"
      value={value}
      onChange={handleChange}
      className="qty-input"
    />
  );
}
